"use strict";
/**
 * Subscription Tier System - Source of Truth
 *
 * This file defines the complete subscription tier configuration for Treu.
 * All tier-related constants should be imported from here to ensure consistency.
 *
 * Tier Summary:
 * - Free: 10 verifications/mo, 2 sources, Gemini 2.5 Flash-Lite
 * - Basic ($9.99): 100/mo, 4 sources, Gemini 3 Flash
 * - Premium ($19.99): 200/mo, 7 sources, Gemini 2.5 Pro, extension, analytics, community read
 * - Professional ($59.99): Unlimited*, 9 sources, Claude Opus 4.6 + Gemini 2.5 Pro, full community
 *
 * *Professional Fair Use: After 500/mo, drops to Gemini 2.5 Pro only
 *
 * @see apps/backend/docs/implementation/subscription-tier-system.md
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIER_FEATURES = exports.TIER_MODELS = exports.TIER_SOURCES = exports.PROFESSIONAL_FAIR_USE_LIMIT = exports.TIER_MONTHLY_PRICES = exports.TIER_DISPLAY_NAMES = exports.TIER_MONTHLY_LIMITS = exports.SubscriptionStatusSchema = void 0;
const zod_1 = require("zod");
exports.SubscriptionStatusSchema = zod_1.z.enum(['active', 'cancelled', 'expired', 'on_trial', 'past_due', 'paused', 'unpaid', 'trialing']);
// Monthly verification limits by tier
exports.TIER_MONTHLY_LIMITS = {
    free: 10,
    basic: 100,
    premium: 200,
    professional: -1, // -1 = unlimited (fair use: 500 before model downgrade)
};
// Display names for each tier (user-facing strings)
exports.TIER_DISPLAY_NAMES = {
    free: 'Free',
    basic: 'Basic',
    premium: 'Premium',
    professional: 'Professional',
};
// Monthly price in USD for each tier (display + proration logic).
// Actual billing is driven by LemonSqueezy variant IDs, not this constant.
exports.TIER_MONTHLY_PRICES = {
    free: 0,
    basic: 9.99,
    premium: 19.99,
    professional: 59.99,
};
// Fair use threshold for professional tier (uses premium model after this)
exports.PROFESSIONAL_FAIR_USE_LIMIT = 500;
exports.TIER_SOURCES = {
    free: ['wikipedia', 'googleFactCheck', 'web'],
    basic: ['wikipedia', 'googleFactCheck', 'pubmed', 'newsApi', 'web'],
    premium: ['wikipedia', 'googleFactCheck', 'pubmed', 'newsApi', 'cdc', 'nih', 'census', 'web'],
    professional: ['wikipedia', 'googleFactCheck', 'pubmed', 'newsApi', 'cdc', 'nih', 'census', 'arxiv', 'bbc', 'web'],
};
exports.TIER_MODELS = {
    free: ['gemini-2.5-flash-lite'],
    basic: ['gemini-3-flash'],
    premium: ['gemini-2.5-pro'],
    professional: ['claude-opus-4.6', 'gemini-2.5-pro'], // Uses both for highest accuracy
};
exports.TIER_FEATURES = {
    free: {
        monthlyLimit: 10,
        sources: exports.TIER_SOURCES.free,
        models: exports.TIER_MODELS.free,
        analytics: false,
        communityAccess: 'none',
        extensionAccess: false,
    },
    basic: {
        monthlyLimit: 100,
        sources: exports.TIER_SOURCES.basic,
        models: exports.TIER_MODELS.basic,
        analytics: false,
        communityAccess: 'none',
        extensionAccess: false,
    },
    premium: {
        monthlyLimit: 200,
        sources: exports.TIER_SOURCES.premium,
        models: exports.TIER_MODELS.premium,
        analytics: true,
        communityAccess: 'read',
        extensionAccess: true,
    },
    professional: {
        monthlyLimit: -1, // Unlimited (fair use: 500 before Claude is dropped)
        sources: exports.TIER_SOURCES.professional,
        models: exports.TIER_MODELS.professional,
        analytics: true,
        communityAccess: 'full',
        extensionAccess: true,
    },
};
//# sourceMappingURL=subscription.js.map